import axios from 'axios'
import { getToken } from '@/utils/auth'
import Vuedata from '@/main'
import { encrypt } from '@/utils/Crypto'

const service = axios.create({
  baseURL: 'https://www.wordkillstu.com.cn/backend'
})

service.interceptors.request.use(
  config => {
    if (getToken()) {
      config.headers['authorization'] = 'Bearer ' + getToken()
      if (config.method === 'post' && config.url !== 'https://www.wordkillstu.com.cn/backend/common/upload') {
        config.data = { data: encrypt(JSON.stringify(config.data)) }
      }
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    const res = response.data

    if (response.request.responseType === 'blob') {
      return res
    }

    if (res.code !== 200) {
      if (res.code === 1001 || res.code === 500) {
        Vuedata.$vux.toast.text(res.msg)
      }
      if (res.code === 401 && res.msg === '获取用户ID异常') {
        Vuedata.$vux.toast.text('当前登录已过期,请重新登录')
        Vuedata.$router.push({ path: '/sysLogin_display' })
      }
      return Promise.reject(new Error(res.msg || res.message || 'Error'))
    }

    return res.data != null ? res.data : res
  },
  error => Promise.reject(error)
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js